export default __webpack_public_path__ + "static/media/IMG_1925.11ee7cf1.jpeg";